<template>
  <div class="document-container">
    <div class="doc-name">
      <p class="name">业务说明</p>
      <p class="update-time">{{currentParams.updateTime}}</p>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>业务说明</span>
      </div>
      <div class="module-text">
        <span>现阶段油柑网开放平台采用的策略是，由采购商拉取油柑网开放平台的对应信息，这是从开发成本和接入难度综合考虑而采用的最优方案。</span>
      </div>
      <div class="module-text">
        <span>1、采购商只需要通过库存查询接口查询相应SKU的库存，并将结果自行存储，后续可根据保存的库存数据下单。</span>
      </div>
      <div class="module-text">
        <span>2、采购商在提交订单时，提交相应SKU的油柑编码，以及需要送往的地区，油柑网会根据送货地址返回可以选择的送货方式，采购商确定送货方式后，可提请油柑网对应的业务员支付，支付成功后，油柑网即会安排发货。</span>
      </div>
      <div class="module-text">
        <span>3、油柑网订单状态的更新需要采购商自行请求。对订单状态和订单详情的维护，我们建议采购商在通过查询接口拿到最新信息后自行存储并维护。具体流程如下图。</span>
      </div>
      <div class="module-img">
        <img src="../../../../assets/images/business-step.png" />
      </div>
    </div>
  </div>
</template>
<script>
import Tables from "@/components/Tables";
import publicData from "@/api/public/index";
import { createOrderApi } from "@/api/order/index";
export default {
  components: {
    Tables
  },
  data() {
    return {
      publicParams: publicData,
      currentParams: createOrderApi
    };
  }
};
</script>
<style lang="less" scoped>
.document-container {
  padding: 0 40px;
  text-align: left;
  .doc-name {
    border-bottom: 1px solid #dedede;
    > .name {
      font-size: 24px;
      text-align: left;
      color: #333;
    }
    > .update-time {
      margin-top: 10px;
      margin-bottom: 30px;
      font-size: 12px;
      color: #666666;
    }
  }
  .request-module-box {
    .module-name {
      height: 60px;
      font-size: 16px;
      line-height: 60px;
      color: #333;
    }
    .table-box {
    }
    .module-text {
      font-size: 14px;
      line-height: 40px;
      text-align: justify;
    }
    .module-img {
      margin-top: 10px;
      img {
        width: 100%;
        display: block;
      }
    }
    .code-example {
      background-color: #e8e8e8;
    }
  }
}
</style>